import { z } from 'zod';
export const KB_CATEGORIES = ['procedures', 'care', 'pricing', 'clinic', 'faq'];
export const kbDocumentSchema = z.object({
    id: z.uuid(),
    title: z.string(),
    category: z.enum(KB_CATEGORIES),
    body: z.string(),
    status: z.enum(['draft', 'approved', 'archived']),
    version: z.number().int(),
    approvedBy: z.object({ id: z.uuid(), name: z.string() }).nullable(),
    approvedAt: z.string().nullable(),
    updatedAt: z.string(),
});
export const saveKbDocumentSchema = z.object({
    title: z.string().trim().min(3, 'Título com ao menos 3 caracteres').max(120),
    category: z.enum(KB_CATEGORIES),
    body: z.string().trim().min(20, 'Escreva ao menos um parágrafo').max(8000),
});
export const aiStatusSchema = z.object({
    enabled: z.boolean(),
    configured: z.boolean(), // há chave do provedor no servidor
    approvedDocuments: z.number().int(),
    assistantName: z.string(),
});
export const aiRunSummarySchema = z.object({
    id: z.uuid(),
    outcome: z.enum(['replied', 'handoff', 'blocked', 'skipped', 'error']),
    reason: z.string().nullable(),
    model: z.string(),
    tools: z.array(z.object({ name: z.string() })),
    citations: z.array(z.object({ id: z.uuid(), title: z.string() })),
    latencyMs: z.number().int().nullable(),
    createdAt: z.string(),
});
//# sourceMappingURL=ai.js.map